module.exports = __webpack_public_path__ + "static/media/commercial.813199b1.jpg";